import axios from 'axios';

class SiteDesignerService {
  baseApiUrl = process.env.SITE_DESIGNER_BASE_API_URL;

  getPages(themeId) {
    return this.get(`/themes/${themeId}/pages/list`)
      .then(res => res.data);
  }

  getPage(themeId, pageId) {
    return this.get(`/themes/${themeId}/pages/${pageId}`);
  }

  createPage(path, title = '', themeId) {
    const data = {
      path,
      themeId,
      title,
      seoData: {
        title: title.replace(' ', '-')
      }
    };

    return this.post(`/themes/${themeId}/pages`, data)
      .then(res => res.data);
  }

  getThemes() {
    return this.get('/themes/drafts')
      .then(res => res.data);
  }

  getTheme(themeId) {
    return this.get(`/themes/${themeId}`)
      .then(res => res.data);
  }

  getInstalledTheme() {
    return this.get('/themes/installed')
      .then(res => res.data);
  }

  setAuthToken(token) {
    this.authToken = token;
  }

  installTheme(themeId) {
    return this.post(`/themes/${themeId}/install`);
  }

  activateTheme(themeId) {
    return this.post(`/themes/${themeId}/install`);
  }

  createNewTheme(themeName = '') {
    this.post('/themes', {
      name: themeName,
      metadata: {
        isPublic: false
      }
    });
  }

  getHttpConfig(options) {
    const config = {
      headers: {
        Authorization: `Bearer ${this.authToken}`
      }
    };

    return options ? { ...config, options } : config;
  }

  get(url) {
    return axios.get(`${this.baseApiUrl}${url}`, this.getHttpConfig());
  }

  post(url, data) {
    return axios.post(`${this.baseApiUrl}${url}`, data, this.getPostConfig());
  }

  getPostConfig() {
    const postConfig = this.getHttpConfig();
    postConfig.headers['Content-Type'] = 'application/json';
    return postConfig;
  }
}

export default new SiteDesignerService();


// WEBPACK FOOTER //
// ./src/app/admin/services/api/SiteDesigner.js